import React from 'react';
import {useSearchParams} from 'react-router-dom';
import {Body, designSystemToken, Icon} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import {ROUTES} from '@/config/routesConstants';
import LegacyBreadcrumbs from '@/components/legacy-breadcrumbs';
import useGoBack from '@/hooks/use-go-back';
import styles from './ProfileVettingBreadcrumbs.module.scss';

const TRANSLATION_PREFIX =
  'components.creator-vetting-report.components.profile-vetting-breadcrumbs';

type BackTarget = {
  labelKey: string;
  fallbackRoute: string;
};

const BACK_TARGETS: Record<string, BackTarget> = {
  vettingHub: {
    labelKey: `${TRANSLATION_PREFIX}.back-to-vetting`,
    fallbackRoute: `${ROUTES.VETTING}/hub`,
  },
  crm: {
    labelKey: 'Back to Creators',
    fallbackRoute: ROUTES.CREATOR_CRM,
  },
};

function ProfileVettingBreadcrumbs() {
  const [searchParams] = useSearchParams();
  const tryGoBack = useGoBack();
  const from = searchParams.get('from') || 'vettingHub';
  const backTarget = BACK_TARGETS[from] || BACK_TARGETS.vettingHub;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    tryGoBack(backTarget.fallbackRoute);
  };

  return (
    <div className={styles.profileVettingBreadcrumbsContainer}>
      <LegacyBreadcrumbs
        breadcrumbs={[
          {
            label: (
              <div className={styles.breadcrumb} onClick={handleClick}>
                <Icon
                  size="medium"
                  appearance="neutral"
                  name="Actions-Arrow-Back-Small"
                  color={designSystemToken('semantic.fg.secondary')}
                />
                <Body
                  size="md"
                  color={designSystemToken('semantic.fg.secondary')}
                >
                  {translate(backTarget.labelKey)}
                </Body>
              </div>
            ),
            link: backTarget.fallbackRoute,
          },
        ]}
      />
    </div>
  );
}

export default ProfileVettingBreadcrumbs;
